import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import { getCorrectLink, getUrlWithoutDomain } from '../../utils/links';
import BurgerMenuItem from './BurgerMenuItem';
import DesktopMenuItem from './DesktopMenuItem';

interface IWordpressMenuItemProps {
  color?: string;
  allowSubmenu?: boolean;
  currentPath: string;
  isActivePage?: boolean;
  isBurgerMenu?: boolean;
  isSubmenuItem?: boolean;
  menuItem: MenuItem;
  menuType: 'desktop' | 'burger';
}

const MenuItem: FCWithClassName<IWordpressMenuItemProps> = (props) => {
  const { isSubmenuItem, menuType, ...rest } = props;
  const data = useStaticQuery<{
    site: { siteMetadata?: { title?: string; siteUrl?: string } };
  }>(graphql`
    query SiteUrl {
      site {
        siteMetadata {
          title
          siteUrl
        }
      }
    }
  `);
  const { site } = data;
  if (!site?.siteMetadata?.siteUrl) return null;
  const siteUrl = site.siteMetadata.siteUrl;
  const styledLinkDestination = getCorrectLink(props.menuItem?.url);
  const currentPathWithoutDomain = getUrlWithoutDomain({
    domain: siteUrl,
    url: props.currentPath,
  });
  const isActivePage =
    props.currentPath === props.menuItem?.url ||
    currentPathWithoutDomain === props.menuItem?.url ||
    Boolean(
      props.menuItem?.childItems?.nodes?.some(
        (childItem) => currentPathWithoutDomain === childItem?.url
      )
    );
  const components = {
    burger: BurgerMenuItem,
    desktop: DesktopMenuItem,
  };
  const ThisComponent = components[props.menuType];
  return (
    <ThisComponent
      {...rest}
      styledLinkDestination={styledLinkDestination}
      isActivePage={isActivePage}
      isSubmenuItem={isSubmenuItem ?? false}
    />
  );
};

MenuItem.defaultProps = {
  allowSubmenu: false,
};

export default MenuItem;
